module.exports = __webpack_public_path__ + "images/category_lp/earphone/assessment_achievements/1_ebd438ff551a8718d21f3fad7afdb3d1.jpg";